import styles from "./Slide.module.scss"
import Image from "../../Image"
import StarActive from "../../../public/images/star_active.svg"
import StarInactive from "../../../public/images/star_inactive.svg"

const ReviewSliderSlide = ({ data }) => {
  // console.log("ReviewSliderSlide", data)

  return (
    <div className={styles.ReviewSlider__Slide}>
      <div>
        <div className={styles.ratingWrapper}>
          {data?.icon && (
            <div className={styles.iconWrapper}>
              <Image
                className={styles.image}
                alt={data?.icon?.alt}
                src={data?.icon?.permalink}
                width={data?.icon?.width}
                height={data?.icon?.height}
              />
            </div>
          )}
          <div className={styles.ratings}>
            {Array.from(Array(5).keys()).map((i) => (
              <Image
                key={i}
                alt={"+"}
                src={i + 1 <= data?.rating ? StarActive : StarInactive}
                width={20}
                height={20}
              />
            ))}
          </div>
        </div>
        {data?.headline && (
          <div
            className={styles.headline}
            dangerouslySetInnerHTML={{ __html: data?.headline }}
          />
        )}
        {data?.text && (
          <div
            className={styles.text}
            dangerouslySetInnerHTML={{ __html: data?.text }}
          />
        )}
      </div>
      {data?.customer && (
        <div>
          <div
            className={styles.customer}
            dangerouslySetInnerHTML={{ __html: data?.customer }}
          />
        </div>
      )}
    </div>
  )
}

export default ReviewSliderSlide
